import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import api from '../utils/api';

const OrderSuccess = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      const response = await api.get(`/orders/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error('Failed to fetch order:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" data-testid="order-success-page">
      <div className="max-w-2xl w-full text-center">
        <CheckCircle className="w-20 h-20 text-gold mx-auto mb-6" />
        <h1 className="font-heading text-4xl sm:text-5xl text-forest mb-4 tracking-tight" data-testid="success-heading">Order Placed Successfully!</h1>
        <p className="text-lg text-muted-foreground mb-8">Thank you for your purchase. Your order has been confirmed.</p>
        
        {order && (
          <div className="bg-neutral-warm p-8 rounded-sm mb-8 text-left">
            <h2 className="text-sm uppercase tracking-[0.2em] text-forest mb-4">Order Details</h2>
            <p className="text-sm text-muted-foreground mb-2">Order ID: {order.order_id}</p>
            <p className="text-sm text-muted-foreground mb-4">Total Amount: ₹{order.total_amount.toLocaleString()}</p>
            <div className="space-y-2">
              {order.items.map((item, idx) => (
                <div key={idx} className="flex justify-between text-sm">
                  <span>{item.name} x {item.quantity}</span>
                  <span>₹{(item.price * item.quantity).toLocaleString()}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/dashboard"
            className="bg-forest text-ivory px-8 py-4 rounded-none hover:bg-gold hover:text-forest transition-colors text-sm uppercase tracking-[0.1em]"
            data-testid="view-orders-button"
          >
            View My Orders
          </Link>
          <Link
            to="/products"
            className="border border-forest text-forest bg-transparent px-8 py-4 rounded-none hover:bg-forest hover:text-ivory transition-colors text-sm uppercase tracking-[0.1em]"
            data-testid="continue-shopping-success-button"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;